import { Disenyos } from '@types'
import { getProxyUrl } from '.'

export async function getProyect(
  navigate: any,
  orden: number,
  texto: string,
  verMisDisenyos: boolean | null,
  verDisenyosCreadoPorMi: boolean | null,
  verUFDisenyosVinculadoDis: boolean | null,
  tipoUsuario?: string,
  idTiendas?: number,
  idDisenyador?: number,
  idUsuarioFinal?: number,
) {
  const callId = Math.random().toString(36).substring(7)

  const url = getProxyUrl('api/Diseno/getDisenyos')
  const date = new Date()

  const idUsuariosStr = sessionStorage.getItem('idUsuarios')
  const idAsignado = idUsuariosStr ? Number(idUsuariosStr) : null

  const shouldIncludeIdAsignado =
    (verMisDisenyos === true ||
      verDisenyosCreadoPorMi === true ||
      verUFDisenyosVinculadoDis === true) &&
    idAsignado !== null &&
    !isNaN(idAsignado) &&
    idAsignado > 0

  const tipoUsuarioForFilter = tipoUsuario || 'U'

  const filtro: any = {
    ordenacion: orden,
    // En Postman funciona con texto: "" (string vacío) en lugar de null
    texto: texto || '',
    // Enviar exactamente como vienen, sin modificaciones
    verMisDisenyos: verMisDisenyos ?? null,
    verDisenyosCreadoPorMi: verDisenyosCreadoPorMi ?? null,
    verUFDisenyosVinculadoDis: verUFDisenyosVinculadoDis ?? null,
    tipoUsuario: tipoUsuarioForFilter,
    // Asegurar que estos campos siempre estén presentes, incluso si son null
    idTiendas: typeof idTiendas === 'number' ? idTiendas : null,
    idDisenyador: typeof idDisenyador === 'number' ? idDisenyador : null,
    idUsuarioFinal: typeof idUsuarioFinal === 'number' ? idUsuarioFinal : null,
    ...(shouldIncludeIdAsignado ? { idAsignado } : {}),
  }

  const body = JSON.stringify({ filtro, date })

  const params = {
    body,
    method: 'POST',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  }

  try {
    const data = await fetch(url, params as RequestInit)
    if (data.status === 200) {
      const json = await data.json()
      return json as Disenyos[]
    } else {
      const errorText = await data.text()
      console.error(`❌ [${callId}] Error backend getDisenyos:`, errorText)
      throw new Error()
    }
  } catch (e: any) {
    console.error(`❌ [${callId}] Error en getProyect:`, e)
    navigate(window.location.pathname + `/error/${e.detail || e.statusText || e.status || e}`)
    throw new Error()
  }
}
